export default [
  {
    id: 'uplifting',
    label: 'Uplifting',
    name: 'uplifting',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_uplifting2.png',
    link: '?moods=uplifting',
  },
  {
    id: 'chilled',
    label: 'Chilled',
    name: 'chilled',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_chilled.png',
    link: '?moods=chilled',
  },
  {
    id: 'energetic',
    label: 'Energetic',
    name: 'energetic',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_energetic.png',
    link: '?moods=energetic',
  },
  {
    id: 'melancholic',
    label: 'Melancholic',
    name: 'melancholic',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_melancholic.png',
    link: '?moods=melancholic',
  },
  {
    id: 'intense',
    label: 'Intense',
    name: 'intense',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_intense.png',
    link: '?moods=intense',
  },
  {
    id: 'euphoric',
    label: 'Euphoric',
    name: 'euphoric',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_euphoric.png',
    link: '?moods=euphoric',
  },
  {
    id: 'epic',
    label: 'Epic',
    name: 'epic',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_epic.png',
    link: '?moods=epic',
  },
  {
    id: 'happy',
    label: 'Happy',
    name: 'happy',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_happy.png',
    link: '?moods=happy',
  },
  {
    id: 'suspense',
    label: 'Suspense',
    name: 'suspense',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_suspense.png',
    link: '?moods=suspense',
  },
  {
    id: 'dreamy',
    label: 'Dreamy',
    name: 'dreamy',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_dreamy.png',
    link: '?moods=dreamy',
  },
  {
    id: 'mysterious',
    label: 'Mysterious',
    name: 'mysterious',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_mysterious.png',
    link: '?moods=mysterious',
  },
  {
    id: 'quirky',
    label: 'Quirky',
    name: 'quirky',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_m_quirky.png',
    link: '?moods=quirky',
  },
];
